import { en } from './const';
export const getText = (text: string) => {
    const lang = localStorage.getItem('lang') || 'zh_CN'
    if (lang === 'zh_CN') return text
    return en[text] || text
}